import { Editor, TinyMCE } from "tinymce";
import { renderFile } from "../Displays/AddInfo";
import { decodeMML, encodeMML, mmlToSvg, setWindowNode } from "./Utils";

declare let tinymce:TinyMCE;

export function loadTask(){
    renderTaskItems();
    loadEditor();
    loadSolutionEditor();
}

function renderTaskItems(){
    taskItems.forEach((item) => {
        renderFile(item);
    })
}

function replaceMath(editor:Editor){
    $(editor.contentDocument).find("math").each((ind, math) => {
        const mml = math.outerHTML

        const img = new Image()
        img.src = mmlToSvg(mml)
        img.setAttribute('data-mathml', encodeMML(mml))
        img.style.verticalAlign = "";
        img.classList.add("pexamath")

        $(math).replaceWith($(img))

        const height = $(img).height()
        const offset = height / 2 - 5
        img.style.verticalAlign = "-" + offset.toString() + "px"

    })
}

function loadEditor(){
    let theme = localStorage.getItem('theme');
    theme = (theme !== null && theme == 'dark') ? 'dark' : 'light';
    const config = {
        selector: "#task-editor",
        language: 'de',
        height: '700px',
        noneditable_noneditable_class: 'mceNonEditable',
        merge_siblings: false, // ACHTUNG: VLT REMOVEN!
        // table_default_attributes: {
        //     'border': '1'
        // },
        // table_default_styles: {
        //     'border-collapsed': 'collapse',
        //     'width': '100%'
        // },
        toolbar_mode: 'sliding',
        content_css: '/css/app/style.min.css,/css/app/editor.css',
//        object_resizing: 'img#bild, img#zeichnung, table, img.Wirisformula, img#plot, img#k-graph, img#graphic, img#embed, img#embed-yt, img#embed-geo, img#picture_input',
        object_resizing: 'img, table, div',
        valid_elements : '*[*]',
        // external_plugins: {
        //     tiny_mce_wiris: 'https://www.wiris.net/demo/plugins/tiny_mce/plugin.js', tiny_mce_wiris_formulaEditor
        // },
        menubar: 'edit format insert',
        menu: {
            edit: { title: "Bearbeiten", items: 'undo redo | cut copy paste | selectall | searchreplace' },
            format: { title: "Format", items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | removeformat' },
        },
        paste_as_text: true,
        plugins: 'paste charmap code noneditable lists advlist table fullscreen textcolor hr codesample emoticons standard-inputs', // autosave, template vlt interessant
        contextmenu: 'input-field popup drawit texttospeech mcscchoices select-field freetext insert-image graph chart labeling ordering math',
        toolar_mode: 'sliding',
        toolbar1: 'bold italic underline forecolor fontselect fontsizeselect | bullist numlist table | code | undo fullscreen',
        toolbar2: 'latex pexamath graph chart popup insert-image  drawit texttospeech | input-field mcscchoices select-field freetext labeling ordering',
        setup: function(editor){
            editor.on("init", function(){
                $("#pexam-editor").css("visibility", "visible");
                $(".editor-preloader").hide();
                if (theme == 'dark'){
                    const b = editor.contentWindow.document.body;
                    b.setAttribute("data-theme", "dark");
                } else {
                    editor.contentWindow.document.body.style.background = '#fff';
                }

                replaceMath(editor)
            });

            editor.on("loadContent", () => {

                // const maths = editor.contentDocument.querySelectorAll("math")
                // maths.forEach((math) => {
                //     const mml = math.outerHTML;

                // })

                replaceMath(editor)

            })

            editor.on("ExecCommand", function(action){
                if (action.command == "insertpexamath" || action.command == "insertLatex" || action.command == "insertmcscchoices"){
                    replaceMath(editor)
                }
            })

            editor.on("dblclick", function(evt){
                if ($(evt.target).hasClass("pexamath")){
                    const mathml = decodeMML(evt.target.getAttribute('data-mathml'))
                    setWindowNode(editor)
                    pexamath.load(mathml)
                    pexamath.afterExport = (mathml:string) => {
                        editor.execCommand("insertpexamath", mathml)
                        // insertToEditor(mathml, editor)
                    }
                }
            })

            // 
            // editor.on("BeforeObjectSelected", function(selected){
            //     if (selected.target.id == "labeling"){
            //         
            //         $(selected.target).removeClass("mceNonEditable");
            //         $(selected.target).attr('contenteditable', "true");
            //         
            //         selected.target.setAttribute("data-mce-resize","1");
            //         
            //         editor.selection.controlSelection.showResizeRect(selected.target);
            //        // $(selected.target).resizable();
            //     } 
            // })
            // editor.on("SelectionChange", function(a, b){
            //     
            //     $("#labeling").addClass('mceNonEditable').attr('contenteditable', 'false');
            // })
            // editor.on("ObjectResized", function(object){
            //     
            //     if (object.target.parentNode.id == "labeling"){
            //         $(object.target.parentNode).attr('contenteditable', 'false');
            //         editor.selection.collapse(false);
            //     }
            // })
        }
    };
    if (theme === 'dark'){
        config.skin = 'oxide-dark';
    }
    tinymce.init(config);
}

function loadSolutionEditor(){
    tinymce.init(initBlockEditor("#solution-editor", 320))
}